export default __webpack_public_path__ + "static/media/main-app-tw-logo.859a68d5cef7649a0ebeecf4a042118c.webp";